import { UserVisitsFilterParameters } from '../user-visits-filter-parameters';

export const InitialVisitFilter = new UserVisitsFilterParameters();
